import React,{useState, useEffect} from 'react'
import './CreateAudit.css';
import Select from "react-select";
import { useDispatch } from 'react-redux';
import Editble_table from '../../audit_reuseble_tables/editble_table';
import mainicon from "../../../../assets/audit_assets/Create_Audit/mainIcon.png"
import branch_name_icon from "../../../../assets/audit_assets/Create_Audit/branch_name.png"
import email_icon from "../../../../assets/audit_assets/Create_Audit/email.png"
import org_name_icon from "../../../../assets/audit_assets/Create_Audit/org_name.png"
import phone_number_icon from "../../../../assets/audit_assets/Create_Audit/phone_number.png"
import status_icon from "../../../../assets/audit_assets/Create_Audit/status.png"
import vendor_Name_icon from "../../../../assets/audit_assets/Create_Audit/vendor_Name.png"
import auditbreadcrumb_icon from "../../../../assets/audit_assets/Create_Audit/auditbreadcrumb_icon.png"
import { getClients} from './../../../../services/global_redux/globale_actions/Client.action';
import {createSingleAuditData, getUnitWiseVendor,getAudit,getlatestAudit,filteredAudit} from './../../../../services/audit_redux/audit_actions/Audit.action';
import intomarkIcon from "../../../../assets/audit_assets/Audit_vendor/intomarkIcon.png"
import branch_icon from "../../../../assets/audit_assets/audit_details/branch_icon.png";
import vendor_icon from "../../../../assets/audit_assets/audit_details/vendor_icon.png";
import { GoChevronDown , GoChevronRight} from "react-icons/go";
import {fetchClientWiseMapTemplate} from './../../../../services/audit_redux/audit_actions/TemplateMap.action'
import MultiSelect from '../../../reUsableTemplates/multiSelectDropdown/MultiSelect';
import { getUserRole} from "./../../../../services/global_redux/globale_actions/Role.action"

function CreateAudit({showSnackbar ,setLoading}) {
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [fetchedData, setfetchedData] = useState([]);
  const [blurtable, setBlurtable]=useState('blurtable');
  const [clientIDs, setClientIDs] = useState([]);
  const [selectedClient , setSelectedClient]= useState('');
  const [selectedClientName , setSelectedClientName]= useState('');
  const dispatch = useDispatch();
  const [createSingleAuditView,setCreateSingleAuditView] = useState(false);
  const [branches, setBranches] = useState([]);
  const [expandedBranches, setExpandedBranches] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState({});
  const [remainderDates, setRemainderDates] = useState([]);
  const [createAuditSteponeErrorValidation,setCreateAuditSteponeErrorValidation] = useState('');
  const [createAuditSteptwoErrorValidation,setCreateAuditSteptwoErrorValidation] = useState('');
  const [templatedata, setTemplatedata] = useState([]);
  const [fromMonth, setFromMonth] = useState('');
  const [toMonth, setToMonth] = useState('');
  const [minMonth, setMinMonth] = useState('');
  const [maxMonth, setMaxMonth] = useState('');
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [step, setStep] = useState(1);
  const [checkCreate, setCheckCreate] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [checkDelete, setCheckDelete] = useState(false);
  const [actionChecked, setActionChecked] = useState(false);
  const addSingleData ={
    audit_name: "",
    client_id:"",
    start_period: "",
    end_period: "",
    templateId: [],
    unit_id_and_vendor_id: [],
    status:"Audit",
    validity_date:"",
    mail_reminder:[]
  }
  const [form, setForm] = useState(addSingleData);
  
  const fetchData = async () =>{
    const response = await dispatch(getlatestAudit(selectedClient));
    if(response.success){
      setMinMonth(response.data.filter[0].start);
      setMaxMonth(response.data.filter[0].end);
      setfetchedData(response.data.data);
    }else{
      setfetchedData([]);
    }
  }
  useEffect(()=>{
    fetchData();
  }, [dispatch,selectedClient]);
  const fetchAllClient = async () => {
    try {
        const response = await dispatch(getClients());
        if (response.data) {
              setClientIDs(response.data);
        }else{
          setClientIDs([]);
        }
    } catch (err) {
        console.error("Failed to fetch clients:", err);
    }
  }
useEffect(() => {
        fetchAllClient();
  }, [dispatch]);
  const header = [
    { key: "client_id", value: "Organization ID", input: "text", icon: org_name_icon, dataIcon: false, highlightName: false ,readOnly:true},
    { key: "client_name", value: "Organization Name", input: "text", icon: org_name_icon, dataIcon: false, highlightName: false ,readOnly:true},
    // { key: "unit_id", value: "Branches", input: "number", icon: branch_name_icon, dataIcon: false, highlightName: false ,readOnly:false },
    // { key: "vendor_name", value: "Vendors", input: "mail", icon: vendor_Name_icon, dataIcon: false, highlightName: false ,readOnly:false },
    { key: "templateId", value: "Templates", input: "text", icon: phone_number_icon, dataIcon: false, highlightName: false ,readOnly:true },
    { key: "period", value: "Audit Period", input: "text", icon: phone_number_icon, dataIcon: false, highlightName: false ,readOnly:true },
    { key: "status", value: "Status", input: "text", icon: status_icon , dataIcon: false, highlightName: true ,readOnly:false}
  ];
  const handledeleteClickOpenalert = async (id) => {
    setLoading(true);
    // try {
    //   const response = await dispatch(deleteHolidaysById(id));
    //   if (response.success == true) {
    //     showSnackbar(response.message, 'success');
    //     setLoading(false);
    //     setEditableRow(null);
    //     fetchdata();
    //   } else {
    //     showSnackbar(response.message, 'warning');
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   showSnackbar('An error occurred', 'error');
    //   setLoading(false);
    // }
  };
  
  const submitdelete = async (id) => {
    // setLoading(true);
    // try {
    //   const response = await dispatch(multiDeleteHolidays(id));
    //   if (response.success == true) {
    //     showSnackbar(response.message.message, 'success');
    //     setLoading(false);
    //     fetchdata();
    //   } else {
    //     showSnackbar(response.message, 'warning');
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   showSnackbar('An error occurred', 'error');
    //   setLoading(false);
    // }

  }
  const handleSaveClick = async (e) => {
    // setLoading(true);
    // try {
    //   const response = await dispatch(updateHolidaysById(editedValues.id, editedValues));
    //   if (response.success == true) {
    //     showSnackbar(response.message, 'success');
    //     setLoading(false);
    //     setEditableRow(null);
    //     fetchdata();
    //   } else {
    //     showSnackbar(response.message, 'warning');
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   showSnackbar('An error occurred', 'error');
    //   setLoading(false);
    // }
  };
  const selectedClientData = async (client_id)=>{
    setSelectedClient(client_id);
    sessionStorage.setItem("selectedAudit", client_id);
    getTemplates(client_id);
    if(client_id && clientIDs){
      clientIDs?.filter((item)=>item.client_id === client_id)
      setSelectedClientName(clientIDs?.filter((item)=>item.client_id === client_id)[0]?.client_name);
      setBlurtable('');
      try{
        const response = await dispatch(getUnitWiseVendor(client_id))
        if (response.success) {
          const branchList = response.data.map((item) => ({
            unit_id: item.unit_id,
            unit_name: item.unit_name,
            vendors: item.vendors || [],
          }));
          setBranches(branchList.filter((item)=>(item.vendors.length > 0)));
        }else{
          setBranches([]);
        }

      }catch(err){
        console.error(err);
      }
    }else{
      setBlurtable('blurtable');
    }
  }
  
  const onSubmit = (e) => {
    e.preventDefault();
    if(selectedBranches.length === 0){
      setCreateAuditSteptwoErrorValidation("Please select atleast one vendor")
    }else{
      const unit_id_and_vendor_id = selectedBranches.map(branchId => ({
        unit_id: branchId,
        vendor_id: selectedVendors[branchId] || []
      }));
      const payload = {
        ...form,
        client_id :selectedClient,
        unit_id_and_vendor_id: unit_id_and_vendor_id,
        mail_reminder: Array.isArray(form.mail_reminder)
          ? form.mail_reminder.map(date => ({
              date,
              reminder_sent: 0,
              sent_at: ""
            }))
          : []
        
      };
      handleFormSubmit(payload);
    }
  };
  
const handleFormSubmit = async (payload) =>{
  setLoading(true);
  try{
    const response = await dispatch(createSingleAuditData(payload));
    if(response.success){
      showSnackbar(response.data.message, 'success');
      setForm(addSingleData);
      setSelectedBranches([]);
      setSelectedVendors({});
      setLoading(false);
      setCreateSingleAuditView(false)
      fetchData();
      setStep(1);
    }else{
      showSnackbar(response.message, 'warning');
      setLoading(false);
    }
  }catch(err){
    setLoading(false);
  }
}
useEffect(() => {
  if (branches.length > 0) {
    setExpandedBranches(branches.map((b) => b.unit_id));
  }
}, [branches]);
const toggleBranch = (branchId) => {
  setExpandedBranches((prev) =>
    prev.includes(branchId)
      ? prev.filter((id) => id !== branchId)
      : [...prev, branchId]
  );
};

const handleSelectAllBranches = () => {
  const allBranchIds = branches.map(b => b.unit_id);
  const allVendorMapping = {};

  clearStepTwoError();
  branches.forEach(branch => {
    allVendorMapping[branch.unit_id] = branch.vendors.map(v => v.vendor_id);
  });

  if (selectedBranches.length === branches.length) {
    setSelectedBranches([]);
    setSelectedVendors({});
  } else {
    setSelectedBranches(allBranchIds);
    setSelectedVendors(allVendorMapping);
  }
};
const isAllSelected = () => {
  if (branches.length === 0) return false;

  return branches.every(branch => {
    const selectedVendorIds = selectedVendors[branch.unit_id] || [];
    return selectedVendorIds.length === branch.vendors.length;
  });
};

const handleBranchToggle = (branchId) => {
  setSelectedBranches((prev) => {
    const isSelected = prev.includes(branchId);
    if (isSelected) {
      const updated = { ...selectedVendors };
      delete updated[branchId];
      setSelectedVendors(updated);
      return prev.filter((id) => id !== branchId);
    } else {
      return [...prev, branchId];
    }
  });
};
const handleVendorToggle = (branchId, vendorId) => {
  clearStepTwoError();
  setSelectedVendors((prev) => {
    const vendors = prev[branchId] || [];

    const updated = vendors.includes(vendorId)
      ? vendors.filter((v) => v !== vendorId)
      : [...vendors, vendorId];
    setSelectedBranches((prevBranches) => {
      if (updated.length > 0) {
        return prevBranches.includes(branchId)
          ? prevBranches
          : [...prevBranches, branchId];
      } else {
        return prevBranches.filter((id) => id !== branchId);
      }
    });

    return { ...prev, [branchId]: updated };
  });
};

const handleCheckAllVendors = (branchId, vendors) => {  
  clearStepTwoError();
  setSelectedVendors((prev) => {
    const current = prev[branchId] || [];
    const allSelected = current.length === vendors.length;

    // If already all selected → clear all, else select all
    const updatedList = allSelected
      ? []
      : vendors.map((v) => v.vendor_id);

    setSelectedBranches((prevBranches) => {
      if (updatedList.length > 0) {
        return prevBranches.includes(branchId)
          ? prevBranches
          : [...prevBranches, branchId];
      } else {
        return prevBranches.filter((id) => id !== branchId);
      }
    });

    return { ...prev, [branchId]: updatedList };
  });
};

useEffect(() => {
  const selectedAudit = sessionStorage.getItem('selectedAudit');
  
  if (selectedAudit && clientIDs.length > 0) {
    setSelectedClient(selectedAudit);
    selectedClientData(selectedAudit);    
    getTemplates(selectedAudit);
  }

}, [clientIDs]);
// const today = new Date();
  const today = new Date().toISOString().split("T")[0];
  const currentMonth = new Date().toISOString().slice(0, 7);
  const getDateRange = (start, end) => {
    const dates = [];
    let current = new Date(start);

    while (current <= new Date(end)) {
      dates.push(current.toISOString().split("T")[0]);
      current.setDate(current.getDate() + 1);
    }

    return dates;
  };
  const validateStep1 = () => {
    if(!form.start_period || !form.end_period || !form.audit_name.trim() || !form.validity_date || form.templateId.length === 0){
      setCreateAuditSteponeErrorValidation("Please fill all the required fields.")
      return false;
    }
    if(form.start_period > form.end_period || form.end_period < form.start_period || form.end_period > currentMonth || form.start_period  > currentMonth){
      setCreateAuditSteponeErrorValidation("Please provide the valid date range.")
      return false;
    }
  
    return true;
  };
  const clearStepOneError = () => {
    if (createAuditSteponeErrorValidation) {
      setCreateAuditSteponeErrorValidation("");
    }
  };
  const clearStepTwoError = () => {
    if (createAuditSteptwoErrorValidation) {
      setCreateAuditSteptwoErrorValidation("");
    }
  };
  
  const getTemplates = async(client)=>{
    try {
      const response = await dispatch(fetchClientWiseMapTemplate(client));
      if(response.success){
        setTemplatedata(response.data[0]?.templates);
      }else{
        setTemplatedata([]);
      }

    } catch (error) {
      
    }
  }
  const templateOptions = templatedata.map((item) => ({
    value: item.template_id,
    label: item.template_name,
  }));
  const filterAuditData = async()=>{
    setLoading(true);
    let fromMonthFormatted = fromMonth; 
    let toMonthFormatted = toMonth;
    if(fromMonth === '' || toMonth === ''){
      showSnackbar("please enter the valid date","error")
      setLoading(false);
      return
    }
    try{
      const response = await dispatch(filteredAudit(selectedClient,fromMonthFormatted,toMonthFormatted));
      console.log(response.data.data);
      
      if(response.success){
        setfetchedData(response.data.data);
        setLoading(false);
      }else{
        setfetchedData([]);
        setLoading(false);
      }
    }catch(err){
      setLoading(false);
    }
  };
  
  const getUserPermission = async () => {
    try {
        const response = await dispatch(getUserRole());
            const rawPermissions = response?.data?.permissions;
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                ? JSON.parse(rawPermissions[0])
                : rawPermissions;
            parsedPermissions.forEach((item) => {
              if (item.section == "Audit" && item.module == "Create Audit") {
                          setCheckCreate(item.action.create);
                          setCheckEdit(item.action.edit);
                          setCheckDelete(item.action.delete);
              }})

    } catch (err) {
      console.error("Failed to fetch states:", err);
    }

};
useEffect(() => {
  getUserPermission();
}, [dispatch]);
const handleKeyDown = (e) => {
  if (e.key === " " && e.target.value.length === 0) {
    e.preventDefault();
  }
};
  return (
    <div className='container-fluid'>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="create-audit-header d-flex ">
          <img src={auditbreadcrumb_icon} alt="" /><h5 className='breadcrumbdata text-white'>Audit <span><GoChevronRight /></span> Create Audit</h5>
          </div>
            <div className="row">
              <Editble_table
                header={header}
                mainIcon={mainicon}
                title={'Create Audit'}
                data={fetchedData}
                setEditableRow={setEditableRow}
                setEditedValues={setEditedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                editableRow={editableRow}
                setLoading={setLoading}
                editedValues={editedValues}
                getEditPermission = {false}
                getDeletePermission = {false}
                getCreatePermission = {checkCreate}
                date={null}
                submitdelete={submitdelete}
                handleSaveClick={handleSaveClick}
                showSnackbar={showSnackbar}
                mainIconColor={"#c9dcff"}
                tableHeaderColor={"#f6f6ff"}
                tableHeaderTextColor={"#2d2be2"}
                actionClass={blurtable}
                clientName={selectedClientName}
                clientId={selectedClient}
                setCreateSingleAuditView={setCreateSingleAuditView}
                setActionChecked={setActionChecked}
                actionChecked={actionChecked}
                filterAuditForm = {
                  <div className="d-flex gap-3 align-items-end">
                    <div className="form-group ms-2">
                      <label>From</label>
                      <input type="month" className="form-control" min={minMonth} max={maxMonth} value={fromMonth} onChange={(e)=>setFromMonth(e.target.value)} />
                    </div>

                    <div className="form-group">
                      <label className='text-bold'>To</label>
                      <input type="month" className="form-control" min={fromMonth} max={maxMonth} value={toMonth} onChange={(e)=>setToMonth(e.target.value)}  disabled={!fromMonth} />
                    </div>

                    <button className="btn btn-primary" onClick={filterAuditData}>Filter</button>
                  </div>
                }
                createOrfilterComp={
                    <div className='select_clinet_create_audit d-flex'>
                      <select className=' form-select' name="" id="" onChange={(e) =>selectedClientData(e.target.value)} value={selectedClient}>
                        <option value="">Organization Name</option>
                        {clientIDs?.map((client) => (
                            <option key={client.client_id} value={client.client_id}>
                                {client.client_name}
                            </option>
                        ))}
                      </select>
                      {blurtable !=="" &&
                              <div className="tooltipcreateVendor bg-white">
                                  <div>Select Organization Name to proceed forward</div>
                              </div>
                      }
                    </div>
                }
              />
              
              {createSingleAuditView && (
                <>
                  <div className="createAuditMainContainer">
                    <div className="createAuditMainContainer-module shadow">
                      <div className="create-audit-forms-header d-flex justify-content-between">
                        <div className="div">
                          <h5>Create Audit</h5>
                          <p>
                            Set up a new audit by defining the scope, compliance period, and responsible vendors or auditors.
                          </p>
                        </div>
                        <button
                          className="into-btn-icon"
                          onClick={() => setCreateSingleAuditView(false)}
                        >
                        <img src={intomarkIcon} alt="" />
                        </button>
                      </div>

                      <div className="create-audit-form-main-div">
                        <div className="container mt-2">
                          <div className="form-container">
                            <form onSubmit={onSubmit}>
                              
                            {branches.length === 0 ?
                                        <p className="text-muted">No Vendors found for the Organisation you selected</p>:
                                  templatedata.length === 0 ?
                                        <p className="text-muted">Please Map the templates for the Organisation you selected </p>:
                              <>
                              {step === 1 && (
                                <>
                                  <div className="create-audit-step-main-header d-flex ">
                                    <div className="create-audit-step-header mb-3 d-flex currentdata me-3">
                                      <div className='createAuditContent-center'>
                                        <div className="createAuditDonut"></div>
                                      </div>
                                      <div>
                                      <h5 className="step-label ">STEP 1</h5>
                                      <h6 className="">Add Audit Details</h6>
                                      <p className="progressTitleProgress">In Progress</p>
                                      
                                      </div>
                                    </div>
                                    <div className="createAuditContent-center me-3">
                                    <div className="steps-line"></div>
                                    </div>
                                    <div className="create-audit-step-header mb-3 d-flex nextdata me-3">
                                      <div className='createAuditContent-center'>
                                        <div className="createAuditCircle"></div>
                                      </div>
                                      <div>
                                      <h5 className="step-label">STEP 2</h5>
                                      <h6 className="">Add Audit Details</h6>
                                      <p className="progressTitlePending">Pending</p>
                                      
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <h6 className='text-danger'><label>{createAuditSteponeErrorValidation}</label></h6>
                                  </div>

                                  <div className="row">
                                    <div className="col-md-6 mb-3">
                                      <label>Start Period <span className='text-danger'>*</span></label>
                                      <input
                                        type="month"
                                        className="form-control"
                                        value={form.start_period}
                                        max={currentMonth}
                                        
                                        required
                                        onChange={(e) =>{
                                          setForm({ ...form, start_period: e.target.value ,end_period:""});
                                          clearStepOneError();  
                                        }}
                                      />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                      <label>End Period <span className='text-danger'>*</span></label>
                                      <input
                                        type="month"
                                        className="form-control"
                                        value={form.end_period}
                                        max={currentMonth}
                                        min={form.start_period}
                                        disabled={!form.start_period}
                                        required
                                        onChange={(e) =>{
                                          setForm({ ...form, end_period: e.target.value });
                                          clearStepOneError();  
                                        }
                                        }
                                      />
                                    </div>
                                    <div className="col-md-6 mb-1">
                                      <label>Audit Name <span className='text-danger'>*</span></label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Audit Name"
                                        value={form.audit_name}
                                        onChange={(e) =>{
                                          const trimmedValue = e.target.value.replace(/^\s+/, "");
                                          setForm({ ...form, audit_name: trimmedValue });
                                          clearStepOneError();  
                                        }
                                        }
                                        onKeyDown={handleKeyDown}
                                        required
                                      />
                                    </div>
                                    <div className="col-md-6 mb-1">
                                      <label>Validity Date <span className='text-danger'>*</span></label>
                                      <input
                                        type="date"
                                        className="form-control"
                                        value={form.validity_date}
                                        min={today}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setForm({ ...form, validity_date: value,mail_reminder: [] });

                                          if (value) {
                                            const range = getDateRange(today, value);
                                            setRemainderDates(
                                              range.map((d) => {
                                                // label: d,
                                                // value: d,
                                                const date = new Date(d);

                                                const day = String(date.getDate()).padStart(2, "0");
                                                const month = String(date.getMonth() + 1).padStart(2, "0");
                                                const year = date.getFullYear();
                                            
                                                const formattedDate = `${day}-${month}-${year}`;
                                            
                                                return {
                                                  label: formattedDate,
                                                  value: formattedDate,
                                                };
                                              })
                                            );
                                          } else {
                                            setRemainderDates([]);
                                          }
                                          clearStepOneError();  
                                        }}
                                        required
                                      />

                                    </div>
                                    <div className="col-md-12 mb-1 createAuditTemplateData">
                                      <label>Reminder Dates</label>
                                      {/* <Select
                                        isMulti
                                        options={remainderDates}
                                        value={
                                          form.mail_reminder?.map((d) => ({ label: d, value: d })) || []
                                        }
                                        onChange={(selected) =>{
                                          setForm({
                                            ...form,
                                            mail_reminder: selected.map((item) => item.value),
                                          })
                                        }
                                        }
                                        placeholder="Select reminder dates"
                                        // className="basic-multi-select"
                                        classNamePrefix="react-select"
                                      /> */}
                                      
                                      <MultiSelect
                                        options={remainderDates}
                                        value={form.mail_reminder} 
                                        onChange={(vals) =>
                                          setForm({
                                            ...form,
                                            mail_reminder: vals,
                                          })
                                        }
                                        openDropdownId={openDropdownId}
                                        setOpenDropdownId={setOpenDropdownId}
                                        placeholder="Select reminder dates"
                                        id="reminder-dates"
                                      />

                                    </div>



                                    <div className="col-md-12 mb-3 createAuditTemplateData">
                                      <label>Templates <span className='text-danger'>*</span></label>
                                      {/* <Select
                                        isMulti
                                        options={templateOptions}
                                        value={form.templateId.map((id) => {
                                          const match = templatedata.find((t) => t.template_name === id);
                                        
                                          return {
                                            value: id,
                                            label: match?.template_name || id,
                                          };
                                        })}
                                        onChange={(selectedOptions) =>{
                                          setForm({
                                            ...form,
                                            templateId: selectedOptions.map((opt) => opt.value),
                                          });
                                          clearStepOneError();  
                                        }
                                        }
                                        placeholder="Select templates..."
                                        classNamePrefix="react-select"
                                      /> */}
                                      <MultiSelect
                                        options={templateOptions}
                                        value={form.templateId} 
                                        onChange={(vals) => {
                                          setForm({ ...form, templateId: vals });
                                          clearStepOneError();
                                        }}
                                        openDropdownId={openDropdownId}
                                        setOpenDropdownId={setOpenDropdownId}
                                        placeholder="Select templates..."
                                        id="template-select"
                                      />

                                    </div>

                                  </div>

                                  <div className="text-end mt-3">
                                    <button
                                      type="button"
                                      className="btn btn-primary px-4"
                                      // onClick={() => setStep(2)}
                                      onClick={() => {
                                        if (!validateStep1()) {
                                          return;
                                        }else{
                                          setCreateAuditSteponeErrorValidation("")
                                          setStep(2);
                                        }
                                      }}
                                    >
                                      Next
                                    </button>
                                  </div>
                                </>
                              )}
                              {step === 2 && (
                                <>
                                  
                                  <div className="create-audit-step-main-header d-flex ">
                                    <div className="create-audit-step-header mb-3 d-flex currentdata me-3">
                                      <div className='createAuditContent-center'>
                                        <div className="createAuditDonut"></div>
                                      </div>
                                      <div>
                                      <h5 className="step-label ">STEP 1</h5>
                                      <h6 className="">Add Audit Details</h6>
                                      <p className="progressTitleCompleted">Completed</p>
                                      
                                      </div>
                                    </div>
                                    <div className="createAuditContent-center me-3">
                                    <div className="steps-line"></div>
                                    </div>
                                    <div className="create-audit-step-header mb-3 d-flex nextdata me-3">
                                      <div className='createAuditContent-center'>
                                        <div className="createAuditDonut"></div>
                                      </div>
                                      <div>
                                      <h5 className="step-label">STEP 2</h5>
                                      <h6 className="">Add Audit Details</h6>
                                      <p className="progressTitleProgress">Pending</p>
                                      
                                      </div>
                                    </div>
                                  </div>
                                  
                                    <div className="row">
                                      <h6 className='text-danger'><label>{createAuditSteptwoErrorValidation}</label></h6>
                                    </div>
                                    <div className="branch-container">
                                      <h6 className="fw-bold mb-2">Branch</h6>
                                      <div className="branchContainertable">
                                        <div className="branchContainertableHeader d-flex sticky-top mb-3 justify-content-between">
                                          <div>
                                          <img src={branch_icon} alt="" /> <span>Branch</span>
                                          </div>
                                          <div className="d-flex">
                                            <span>Select All </span><input
                                              type="checkbox"
                                              className="ms-1"
                                              // checked={selectedBranches.length === branches.length}
                                              checked={branches.length > 0 && isAllSelected()}
                                              onChange={handleSelectAllBranches}/>
                                          </div>
                                        </div>
                                        <div className="branchContainertablebody">
                                          {branches.map((branch, index) => {
                                            const allVendorsChecked =
                                              selectedVendors[branch.unit_id]?.length ===
                                              branch.vendors.length;

                                            return (
                                              <div
                                                key={index}
                                                className="branch-card branchSelectionContainer"
                                              >
                                                <div className="d-flex justify-content-between align-items-center branchNameDiv">
                                                  <div className="d-flex align-items-center gap-2 ">
                                                    {/* <input
                                                      type="checkbox"
                                                      checked={selectedBranches.includes(branch.unit_id)}
                                                      onChange={() =>
                                                        handleBranchToggle(branch.unit_id)
                                                      }
                                                    /> */}
                                                    <span className="fw-semibold">
                                                      {branch.unit_id}
                                                    </span>
                                                  </div>
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-light"
                                                    onClick={() => toggleBranch(branch.unit_id)}
                                                  >
                                                    {expandedBranches.includes(branch.unit_id)
                                                      ? <span><GoChevronRight /></span>
                                                      : <span><GoChevronDown /></span>}
                                                  </button>
                                                </div>

                                                {expandedBranches.includes(branch.unit_id) && (
                                                  <div className="vendor-list p-2">
                                                    <div>
                                                      <div className="d-flex justify-content-between align-items-center">
                                                        <div className='d-flex vendorDataMainHeader pt-1'>
                                                        <img src={vendor_icon} alt="" />
                                                        <h6 className="">
                                                          Vendor Name
                                                        </h6>
                                                        </div>
                                                        {branch.vendors.length > 0 && (
                                                          <div className="form-check">
                                                            <input
                                                              type="checkbox"
                                                              className="mt-2"
                                                              checked={allVendorsChecked}
                                                              onChange={() =>
                                                                handleCheckAllVendors(
                                                                  branch.unit_id,
                                                                  branch.vendors
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </div>
                                                      {branch.vendors.map((vendor) => (
                                                        <div
                                                          key={vendor.vendor_id}
                                                          className="vendorSelectCheckboxDiv"
                                                        >
                                                          <input
                                                            className=""
                                                            type="checkbox"
                                                            checked={
                                                              selectedVendors[branch.unit_id]?.includes(
                                                                vendor.vendor_id
                                                              ) || false
                                                            }
                                                            onChange={() =>
                                                              handleVendorToggle(
                                                                branch.unit_id,
                                                                vendor.vendor_id
                                                              )
                                                            }
                                                          />
                                                          <label className="">
                                                            {vendor.vendor_name}
                                                          </label>
                                                        </div>
                                                      ))}
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                      
                                    </div>

                                  <div className="d-flex justify-content-between mt-4">
                                    <button
                                      type="button"
                                      className="btn btn-outline-primary px-4"
                                      onClick={() => setStep(1)}
                                    >
                                      Back
                                    </button>
                                    <button type="submit" className="btn btn-primary px-4">
                                      Submit
                                    </button>
                                  </div>
                                </>
                              )}
                              </>
                            }
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

        </div>
      </div>
    </div>
  )
}

export default CreateAudit